import QuestionGame from '../../services/QuestionGame'
import {updateCredits} from '../../services/Draugas.js'

import {UPDATED} from './wallet'

export const UNCOVERING = 'question-game/votes/UNCOVERING'
export const UNCOVERED = 'question-game/votes/UNCOVER'
export const VOTED_BACK = 'question-game/votes/VOTED_BACK'

export function uncover(hiddenId, online) {
  return dispatch => {

      dispatch({
          type: UNCOVERING,
          hiddenId: hiddenId,
      })

    QuestionGame.uncover(hiddenId, online, response => {

      if (response.success) {

        dispatch({
          type: UNCOVERED,
          valentine: response.valentine
        })

        dispatch({
          type: UPDATED,
          votesLeft: response.freePoints.votesLeft,
          disabled: response.freePoints.disabled,
          credits: response.credits,
          freePoints: response.freePoints.count
        })

        updateCredits(response.credits)
      }
      else {

        typeof window.showOutOfCredits === 'function' && window.showOutOfCredits()
      }
    })
  }
}

export function voteBack(gameType, valentine, yes) {
  return dispatch => {
    QuestionGame.voteBack(gameType, valentine.id, yes, () => {
      dispatch({
        type: VOTED_BACK,
        valentine: valentine
      })
    })
  }
}
